import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_3 = { class: "stat-card d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_4 = { class: "stat-icon d-flex flex-coulmn justify-content-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "stat-info text-end" }
const _hoisted_8 = { class: "d-block fs-14 fw-medium" }
const _hoisted_9 = { class: "fw-black mb-0 lh-1" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status, (state) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-xxl-3 col-xl-6 col-md-6 col-sm-6",
        key: state.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: state.imgBlurIcon,
                alt: "Image",
                class: "blur-icon"
              }, null, 8, _hoisted_5),
              _createElementVNode("img", {
                src: state.imgIcon,
                alt: "Image"
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(state.title), 1),
              _createElementVNode("h4", _hoisted_9, [
                (state.title !== 'Quantity')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "HTG "))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(state.value), 1)
              ])
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}